import { render, staticRenderFns } from "./AppDirect.vue?vue&type=template&id=4f02aeb6&"
import script from "./AppDirect.vue?vue&type=script&lang=js&"
export * from "./AppDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports